var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-detail wp-page"},[_c('Breadcrumb',{attrs:{"items":_vm.breadcrumb}}),_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.article)?_c('recipe-detail',{attrs:{"article":_vm.article}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }